import { render, staticRenderFns } from "./ModifyLanguages.vue?vue&type=template&id=74c9c119&scoped=true&"
import script from "./ModifyLanguages.vue?vue&type=script&lang=js&"
export * from "./ModifyLanguages.vue?vue&type=script&lang=js&"
import style0 from "./ModifyLanguages.vue?vue&type=style&index=0&id=74c9c119&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c9c119",
  null
  
)

export default component.exports